import S3UploadController from "./s3_upload_controller"

// Connects to data-controller="import-schema-upload"
// Extends s3_upload_controller to avoid code duplication
export default class extends S3UploadController {
  static values = {
    ...S3UploadController.values,
    tableDefinitionId: String
  }

  connect() {
    // The parent's connect() initialises the upload state; overriding it
    // without calling super would leave that state unset.
    super.connect()
    console.log("Import Schema Upload controller connected")
  }

  // Override to use the table-level presigned upload endpoint
  get presignedUploadUrl() {
    return `/table_definitions/${this.tableDefinitionIdValue}/import_schema_presigned_upload`
  }

  // Override to customize button text
  get uploadingText() {
    return "Uploading..."
  }

  get processingText() {
    return "Processing..."
  }

  get defaultButtonText() {
    return "Import Schema"
  }
}
